import { Outlet } from "react-router-dom";

export function AuthLayout() {
  return (
    <div className="grid min-h-svh place-items-center bg-background p-6">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <h1 className="text-2xl font-semibold tracking-tight">Lovd</h1>
          <p className="text-sm text-muted-foreground">Private family memories</p>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
